import { composeClasses, generateUtilityClass } from "@tino-frontend/coreui";
function getUtilityClass(slot) {
  return generateUtilityClass("TrueMarkdown", slot);
}
const useUtilityClasses = (ownerState) => {
  const { classes, reduceHeading, allLinkAsTargetBlank, limitHeading } = ownerState;
  const slots = {
    root: [
      "root",
      reduceHeading ? "reduceHeading" : void 0,
      allLinkAsTargetBlank ? "allLinkAsTargetBlank" : void 0,
      limitHeading ? "limitHeading" : void 0
    ]
  };
  return composeClasses(slots, getUtilityClass, classes);
};
export {
  getUtilityClass,
  useUtilityClasses
};
//# sourceMappingURL=markdown.classes.js.map
